export default __webpack_public_path__ + "static/media/fuel-gun.2e0238d1.svg";